var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUPi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 45.3 16",
    style: {
      enableBackground: "new 0 0 45.3 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#27803B;}\r\n\t.st1{fill:#E9661C;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upi",
    transform: "translate(19983.703 11631.841)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g30",
    transform: "translate(-19983.703 -11618.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path32",
    d: "M0.4,0h0.3L0.4,1.3c-0.1,0.1,0,0.3,0,0.4c0.1,0.1,0.2,0.2,0.4,0.1c0.2,0,0.3,0,0.4-0.1 c0.1-0.1,0.2-0.3,0.2-0.4L1.8,0h0.3L1.8,1.3c0,0.3-0.2,0.5-0.4,0.7C1.2,2.2,1,2.2,0.7,2.2C0.5,2.3,0.3,2.2,0.1,2 C0,1.8,0,1.6,0,1.3L0.4,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g34",
    transform: "translate(-19981.65 -11618.181)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path36",
    d: "M0,2.3L0.5,0l1,1.3c0,0,0.1,0.1,0.1,0.1s0.1,0.1,0.1,0.1l0.4-1.5h0.3L1.9,2.3L0.8,1c0,0-0.1-0.1-0.1-0.1 c0,0,0-0.1-0.1-0.1L0.3,2.3H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g38",
    transform: "translate(-19979.271 -11618.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path40",
    d: "M0,2.2L0.5,0h0.3L0.3,2.2H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g42",
    transform: "translate(-19978.436 -11618.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path44",
    d: "M0,2.2L0.5,0h1.2L1.6,0.3H0.8L0.7,0.8h0.8L1.4,1.1H0.6l-0.2,1H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g46",
    transform: "translate(-19976.877 -11618.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path48",
    d: "M0,2.2L0.5,0h0.3L0.3,2.2H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g50",
    transform: "translate(-19976.041 -11618.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path52",
    d: "M0,2.2L0.5,0h1.2L1.6,0.3H0.8L0.7,0.8h0.8L1.4,1.2H0.6L0.4,1.9h0.8L1.2,2.2L0,2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g54",
    transform: "translate(-19974.469 -11618.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path56",
    d: "M0.4,1.8h0.3c0.1,0,0.2,0,0.4,0c0.1,0,0.2-0.1,0.2-0.1c0.1-0.1,0.2-0.2,0.2-0.3c0.1-0.1,0.1-0.2,0.1-0.4 c0-0.1,0-0.2,0-0.4c0-0.1-0.1-0.2-0.1-0.3C1.6,0.4,1.5,0.4,1.4,0.3c-0.1,0-0.3,0-0.4,0H0.8L0.4,1.8z M0,2.2L0.5,0H1 c0.2,0,0.4,0,0.6,0c0.1,0,0.2,0.1,0.3,0.2C2,0.3,2.1,0.4,2.1,0.6c0,0.2,0,0.3,0,0.5c0,0.2-0.1,0.4-0.2,0.5C1.7,1.7,1.6,1.9,1.5,2 C1.4,2,1.2,2.1,1.1,2.1c-0.2,0-0.4,0.1-0.6,0L0,2.2L0,2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g58",
    transform: "translate(-19971.389 -11618.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path60",
    d: "M0.6,0.9L0.6,0.9c0.2,0,0.4,0,0.5-0.1c0.1-0.1,0.1-0.1,0.1-0.2c0-0.1,0-0.2,0-0.2C1.1,0.3,1,0.3,0.9,0.3H0.8 L0.6,0.9z M0.6,1.2l-0.2,1H0L0.5,0H1c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.2,0.1c0.1,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.2,0,0.3 c0,0.1-0.1,0.2-0.1,0.3C1.5,1,1.4,1,1.3,1.1c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0-0.2,0-0.3,0L0.6,1.2L0.6,1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g62",
    transform: "translate(-19970.264 -11618.181)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path64",
    d: "M0.9,1.4h0.6L1.4,0.9c0,0,0-0.1,0-0.1s0-0.1,0-0.1c0,0,0,0.1-0.1,0.1s0,0.1-0.1,0.1L0.9,1.4z M1.7,2.3 L1.6,1.7H0.7L0.4,2.3H0L1.6,0L2,2.3H1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g66",
    transform: "translate(-19967.92 -11618.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path68",
    d: "M0.2,2.2l0.2-1L0,0h0.4l0.3,0.7c0,0,0,0,0,0.1s0,0.1,0,0.1c0,0,0-0.1,0.1-0.1s0-0.1,0.1-0.1L1.4,0h0.3l-1,1.2 l-0.2,1H0.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g70",
    transform: "translate(-19966.631 -11618.188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path72",
    d: "M2.2,1.2c0,0,0-0.1,0-0.1c0-0.1,0-0.1,0-0.2c0,0.1,0,0.1-0.1,0.1c0,0.1-0.1,0.1-0.1,0.2L1.2,2.3L0.9,1.2 c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0,0.1,0,0.1c0,0,0,0.1-0.1,0.2L0.3,2.3H0L1,0l0.3,1.4c0,0,0,0.1,0,0.1s0,0.1,0,0.2 c0-0.1,0.1-0.1,0.2-0.2l0-0.1L2.5,0l0,2.3H2.2L2.2,1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g74",
    transform: "translate(-19963.881 -11618.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path76",
    d: "M0,2.2L0.5,0h1.2L1.6,0.3H0.8L0.7,0.8h0.8L1.4,1.2H0.6L0.4,1.9h0.8L1.2,2.2L0,2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g78",
    transform: "translate(-19962.307 -11618.181)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path80",
    d: "M0,2.3L0.5,0l1,1.3c0,0,0.1,0.1,0.1,0.1s0.1,0.1,0.1,0.1l0.4-1.5h0.3L1.9,2.3L0.8,1c0,0-0.1-0.1-0.1-0.1 c0,0,0-0.1-0.1-0.1L0.3,2.3H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g82",
    transform: "translate(-19959.707 -11618.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path84",
    d: "M0.9,0.3L0.5,2.2H0.1l0.4-1.9H0L0.1,0h1.5L1.5,0.3L0.9,0.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g86",
    transform: "translate(-19958.445 -11618.144)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path88",
    d: "M0,1.8l0.3-0.1c0,0.1,0,0.2,0.1,0.2C0.5,1.9,0.6,2,0.6,1.9c0.1,0,0.2,0,0.3-0.1C1,1.8,1,1.7,1.1,1.6 c0-0.1,0-0.2-0.2-0.3l-0.1,0C0.6,1.2,0.5,1.1,0.4,0.9c-0.1-0.1-0.1-0.2,0-0.3c0-0.2,0.1-0.3,0.3-0.4C0.8,0.1,0.9,0,1.1,0 c0.1,0,0.3,0,0.4,0.1c0.1,0.1,0.1,0.2,0.2,0.3L1.3,0.5c0-0.1-0.1-0.1-0.1-0.2c0,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.2,0.1 c-0.1,0-0.1,0.1-0.1,0.2c0,0.1,0.1,0.3,0.3,0.4l0,0C1.2,1,1.3,1.1,1.4,1.2c0.1,0.1,0.1,0.2,0,0.4c0,0.2-0.2,0.4-0.3,0.5 C1,2.2,0.8,2.3,0.6,2.3c-0.2,0-0.3,0-0.4-0.1C0,2.1,0,1.9,0,1.8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g90",
    transform: "translate(-19955.908 -11618.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path92",
    d: "M0,2.2L0.5,0h0.3L0.3,2.2H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g94",
    transform: "translate(-19955.072 -11618.181)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path96",
    d: "M0,2.3L0.5,0l1,1.3c0,0,0.1,0.1,0.1,0.1s0.1,0.1,0.1,0.1l0.4-1.5h0.3L1.9,2.3L0.8,1c0,0-0.1-0.1-0.1-0.1 c0,0,0-0.1-0.1-0.1L0.3,2.3H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g98",
    transform: "translate(-19952.475 -11618.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path100",
    d: "M0.9,0.3L0.5,2.2H0.1l0.4-1.9H0L0.1,0h1.5L1.5,0.3L0.9,0.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g102",
    transform: "translate(-19951.197 -11618.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path104",
    d: "M0,2.2L0.5,0h1.2L1.6,0.3H0.8L0.7,0.8h0.8L1.4,1.2H0.6L0.4,1.9h0.8L1.2,2.2L0,2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g106",
    transform: "translate(-19949.625 -11618.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path108",
    d: "M0.6,0.9L0.6,0.9c0.2,0,0.3,0,0.4-0.1c0.1-0.1,0.1-0.1,0.1-0.2c0-0.1,0-0.2,0-0.3C1.1,0.3,1,0.3,0.8,0.3H0.8 L0.6,0.9z M0.6,1.2l-0.2,1H0L0.5,0H1c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.2,0.1c0.1,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.2,0,0.3 c0,0.2-0.1,0.3-0.2,0.4C1.3,1.1,1.1,1.2,1,1.2l0.5,1H1.1L0.6,1.2L0.6,1.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g110",
    transform: "translate(-19947.969 -11618.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path112",
    d: "M0,2.2L0.5,0h1.2L1.6,0.3H0.8L0.7,0.8h0.8L1.4,1.1H0.6l-0.2,1H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g114",
    transform: "translate(-19946.811 -11618.181)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path116",
    d: "M0.9,1.4h0.6L1.4,0.9c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1c0,0,0,0.1-0.1,0.1s0,0.1-0.1,0.1L0.9,1.4z M1.7,2.3 L1.6,1.7H0.7L0.4,2.3H0L1.6,0L2,2.3H1.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g118",
    transform: "translate(-19944.486 -11618.147)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path120",
    d: "M2,0.6C1.9,0.5,1.8,0.4,1.7,0.4c-0.1,0-0.2-0.1-0.3-0.1c-0.2,0-0.4,0.1-0.6,0.2C0.6,0.7,0.4,0.9,0.4,1.1 c-0.1,0.2,0,0.4,0.1,0.6C0.6,1.9,0.8,2,0.9,2c0.1,0,0.3,0,0.4-0.1c0.1-0.1,0.3-0.1,0.4-0.2L1.6,2.1C1.5,2.1,1.4,2.2,1.3,2.2 c-0.1,0-0.2,0.1-0.4,0c-0.1,0-0.3,0-0.4-0.1C0.3,2.1,0.2,2.1,0.2,2C0.1,1.8,0,1.7,0,1.6c0-0.1,0-0.3,0-0.4c0-0.2,0.1-0.3,0.2-0.4 c0.1-0.1,0.2-0.3,0.3-0.4C0.7,0.2,0.8,0.1,1,0.1C1.1,0,1.3,0,1.4,0c0.1,0,0.2,0,0.3,0.1c0.1,0,0.2,0.1,0.3,0.2L2,0.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g122",
    transform: "translate(-19942.494 -11618.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path124",
    d: "M0,2.2L0.5,0h1.2L1.6,0.3H0.8L0.7,0.8h0.8L1.4,1.2H0.6L0.4,1.9h0.8L1.2,2.2L0,2.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g126",
    transform: "translate(-19951.119 -11631.841)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path128",
    d: "M2.4,11.9H0L3.3,0h2.4L2.4,11.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g130",
    transform: "translate(-19967.012 -11631.806)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path132",
    d: "M17,0.3C16.8,0.1,16.6,0,16.3,0h-13L2.6,2.3h11.8l-0.7,2.5H4.3v0H2l-2,7.1h2.4l1.3-4.7h10.6 c0.3,0,0.7-0.1,0.9-0.3c0.3-0.2,0.5-0.5,0.6-0.8l1.3-4.7C17.2,0.9,17.2,0.6,17,0.3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g134",
    transform: "translate(-19982.51 -11631.806)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path136",
    d: "M14.1,11.1c-0.1,0.5-0.6,0.8-1,0.8H0.9c-0.3,0-0.6-0.1-0.7-0.3C0,11.3-0.1,11,0.1,10.7L3,0h2.4L2.7,9.6h9.5 L14.8,0h2.4L14.1,11.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g138",
    transform: "translate(-19944.693 -11631.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path140",
    className: "st0",
    d: "M3.3,0l3,5.9L0,11.9L3.3,0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g142",
    transform: "translate(-19946.793 -11631.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path144",
    className: "st1",
    d: "M3.3,0l3,5.9L0,11.9L3.3,0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUPi);
export default __webpack_public_path__ + "static/media/UPi.b498b64e14ca7a0b351f6734608b3647.svg";
export { ForwardRef as ReactComponent };